export const deleteObjectField = <T extends object>(obj: T, field: keyof T) => {
  const newObj = { ...obj };
  delete newObj[field];
  return newObj;
};

export const deleteObjectFields = <T extends object>(
  obj: T,
  fields: (keyof T)[],
) => {
  return fields.reduce((acc, curr) => {
    return deleteObjectField(acc, curr);
  }, obj);
};
